import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  loading = false
  supportArr = []
  pageNo
  pageSize
  totalItems
  showDelete = false
  activeTab = "OPEN"

  arr = [1, 2, 3, 4, 5]

  constructor(private router: Router, private authService: AuthservicesService) {
    this.pageSize = environment.pageSize;
  }
  ngOnInit(): void {
    this.getSupport(1, this.activeTab)
  }

  getScrollTo(id: string) {
    this.activeTab = id
    this.loading = false
    this.getSupport(this.pageNo, this.activeTab)
    const element = this.getElementById(id)

  }

  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }


  getSupport(event, status) {
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.authService.getSupport(skip, this.pageSize, status, '').subscribe((res: any) => {
      this.supportArr = res.items

      this.loading = true
      this.totalItems = res.total
    },
      error => {
        this.loading = true;
        // this.authService.successMessage(error.error.message, 'error')
      })
  }

getComment(){
  
}


  navigate(id) {
    this.router.navigate(['/support/chat-support',id])
  }
}
